import React from 'react';
import PropTypes from 'prop-types';
import { parse } from 'qs';
import { SelectField } from '@flightstats/component-lib';
import moment from 'moment';
import { identity } from 'ramda';

import AirportSelect from '../../../../../../src/components/lib/AirportSelect';
import AirlineSelect from '../../../../../../src/components/lib/AirlineSelect';
import { dateFormatString, timeFormatSelect } from '../../../../../../src/lib/date-time-format';
import componentBase from '../../../../../../src/lib/component-base';
import {
  setAirline,
  setFlightNumber,
  setDepartureAirport,
  setArrivalAirport,
  setDepartureDate,
  setDepartureTime,
  setAdvancedSearchUrl,
  setFlightTrackerSearchError,
  setFlightTrackerQueryError,
  setSecondaryAdvancedSearchActionAirline,
  setSecondaryAdvancedSearchActionDepAirport,
  setSecondaryAdvancedSearchActionArrAirport,
  setSecondaryAdvancedSearchActionDepDate,
  setSecondaryAdvancedSearchActionTime,
  updatingFlightNumberInput,
  setAllAdvancedSearchAsyncBools,
} from '../../../../redux/Search/actions';

@componentBase('AdvancedSearch')
export default class AdvancedSearch extends React.Component {
  static propTypes = {
    buildUrl: PropTypes.func,
    dispatch: PropTypes.func,
    airline: PropTypes.object,
    departureAirport: PropTypes.object,
    arrivalAirport: PropTypes.object,
    flightNumber: PropTypes.string,
    departureDate: PropTypes.string,
    departureTime: PropTypes.number,
    history: PropTypes.object,
    changingFlightNumberInput: PropTypes.bool,
    secondaryAdvancedSearchActionAirline: PropTypes.bool,
    secondaryAdvancedSearchActionDepAirport: PropTypes.bool,
    secondaryAdvancedSearchActionArrAirport: PropTypes.bool,
    secondaryAdvancedSearchActionDepDate: PropTypes.bool,
    secondaryAdvancedSearchActionTime: PropTypes.bool,
    secondaryAdvancedSearchAction: PropTypes.func,
    submit: PropTypes.func,
  };

  componentDidMount() {
    const { history, dispatch } = this.props;
    const { location } = history;
    const qs = location.search && location.search ?
      this.extractError(location.search) :
      '';

    qs && dispatch(setFlightTrackerQueryError(qs));
    dispatch(setDepartureDate(this.initialDepartureDate(), false));
  }

  componentWillReceiveProps() {
    if (this.props.secondaryAdvancedSearchActionAirline) {
      this.props.dispatch(setSecondaryAdvancedSearchActionAirline(false));
    }
    if (this.props.secondaryAdvancedSearchActionDepAirport) {
      this.props.dispatch(setSecondaryAdvancedSearchActionDepAirport(false));
    }
    if (this.props.secondaryAdvancedSearchActionArrAirport) {
      this.props.dispatch(setSecondaryAdvancedSearchActionArrAirport(false));
    }
    if (this.props.secondaryAdvancedSearchActionDepDate) {
      this.props.dispatch(setSecondaryAdvancedSearchActionDepDate(false));
    }
    if (this.props.secondaryAdvancedSearchActionTime) {
      this.props.dispatch(setSecondaryAdvancedSearchActionTime(false));
    }
  }

  componentWillUnmount() {
    // clear error message where they may have been set
    const {
      dispatch,
    } = this.props;
    dispatch(setFlightTrackerSearchError());
    dispatch(setFlightTrackerQueryError({ error: '' }));

    // reset the booleans that trigger secondary calls
    dispatch(updatingFlightNumberInput(false));
    dispatch(setAllAdvancedSearchAsyncBools(false));
    // reset the booleans that trigger secondary calls
  }

  timeOfTravelOptions = [
    { value: 0, label: timeFormatSelect(this.context.currentUser, '00:00 - 06:00', '12:00 am - 6:00 am') },
    { value: 6, label: timeFormatSelect(this.context.currentUser, '06:00 - 12:00', '6:00 am - 12:00 pm') },
    { value: 12, label: timeFormatSelect(this.context.currentUser, '12:00 - 18:00', '12:00 pm - 6:00 pm') },
    { value: 18, label: timeFormatSelect(this.context.currentUser, '18:00 - 00:00', '6:00 pm - 12:00 am') },
  ];

  buildDateOption = momentDate => (
    { value: momentDate.format('YYYY/M/D'), label: momentDate.format(dateFormatString(this.context.currentUser)) }
  )

  dateOfTravelOptions = [
    this.buildDateOption(moment.utc().subtract(3, 'days')),
    this.buildDateOption(moment.utc().subtract(2, 'days')),
    this.buildDateOption(moment.utc().subtract(1, 'days')),
    this.buildDateOption(moment.utc()),
    this.buildDateOption(moment.utc().add(1, 'days')),
    this.buildDateOption(moment.utc().add(2, 'days')),
    this.buildDateOption(moment.utc().add(3, 'days')),
  ];

  initialDepartureDate = () => {
    const { departureDate } = this.props;
    if (departureDate) {
      return moment(departureDate, 'YYYY/MM/DD').format('YYYY/M/D');
    }
    return moment().format('YYYY/M/D');
  }

  extractError = qs => parse(qs, { ignoreQueryPrefix: true });

  flightNumHandler = (event) => {
    const flightNumber = event.target.value;
    if (/^\+?(0|[1-9]\d*)$/.test(flightNumber) || flightNumber === '') {
      this.props.dispatch(setFlightNumber(flightNumber));
    }
  }

  changeState = (reduxAction, option, triggeredByEnter) => {
    this.props.dispatch(reduxAction(option, triggeredByEnter));
  }

  changeAirline =
    (option, triggeredByEnter) => this.changeState(setAirline, option, triggeredByEnter);
  changeDepartureAirport =
    (option, triggeredByEnter) => this.changeState(setDepartureAirport, option, triggeredByEnter);
  changeArrivalAirport =
    (option, triggeredByEnter) => this.changeState(setArrivalAirport, option, triggeredByEnter);
  changeDepartureDate =
    (option, triggeredByEnter) =>
      this.props.dispatch(setDepartureDate(option.value, triggeredByEnter));
  changeDepartureTime =
    (option, triggeredByEnter) =>
      this.props.dispatch(setDepartureTime(option.value, triggeredByEnter));

  handleKeyDownFlightNumber = (e) => {
    if (e.keyCode === 13) {
      // enter has been pressed
      this.secondaryAction(true);
    }
  }

  handleBlurFlightNumber = () => {
    this.props.dispatch(updatingFlightNumberInput(false));
  }

  secondaryAction = (fromKeyDownHandler) => {
    const url = this.props.buildUrl(this.props);
    this.props.dispatch(setAdvancedSearchUrl(url));
    if (!fromKeyDownHandler && !this.props.changingFlightNumberInput) {
      this.props.submit(null, url);
    } else if (fromKeyDownHandler) {
      // enter pressed in the flight number input inputField
      this.props.submit(null, url);
    }
  }

  render() {
    return (
      <section className='fs-search-card'>
        <div>
          <div className='advanced-search-bar half-search-bar advanced-airline-search'>
            <p>Airline</p>
            <AirlineSelect
              name='airline'
              airline={this.props.airline}
              onChange={this.changeAirline}
              secondaryAction={
                this.props.secondaryAdvancedSearchActionAirline ?
                this.secondaryAction : identity
              }
              onBlur={
                () => (
                  this.changeState(setAllAdvancedSearchAsyncBools, false)
                )
              }
            />
          </div>
          <div className='advanced-search-bar advanced-search-bar-right half-search-bar'>
            <p>Flight Number</p>
            <input
              className='advanced-search-text-field'
              onChange={this.flightNumHandler}
              type='text'
              name='flight-number'
              value={this.props.flightNumber}
              placeholder='Example: 200'
              autoComplete='off'
              onKeyDown={this.handleKeyDownFlightNumber}
              onBlur={this.handleBlurFlightNumber}
            />
          </div>
        </div>
        <div>
          <div className='advanced-search-bar advanced-departure-airport-search'>
            <p>Departure Airport</p>
            <AirportSelect
              inputTitle='Departure Airport'
              name='departureAirport'
              onChange={this.changeDepartureAirport}
              airport={this.props.departureAirport}
              secondaryAction={
                this.props.secondaryAdvancedSearchActionDepAirport ?
                  this.secondaryAction : identity
              }
              onBlur={
                () => (
                  this.changeState(setAllAdvancedSearchAsyncBools, false)
                )
              }
            />
          </div>
        </div>
        <div>
          <div className='advanced-search-bar advanced-arrival-airport-search'>
            <p>Arrival Airport</p>
            <AirportSelect
              name='arrivalAirport'
              inputTitle='Arrival Airport'
              onChange={this.changeArrivalAirport}
              airport={this.props.arrivalAirport}
              secondaryAction={
                this.props.secondaryAdvancedSearchActionArrAirport ?
                  this.secondaryAction : identity
              }
              onBlur={
                () => (
                  this.changeState(setAllAdvancedSearchAsyncBools, false)
                )
              }
            />
          </div>
        </div>
        <div style={{ paddingBottom: '11px' }}>
          <div className='advanced-search-bar half-search-bar'>
            <p>Date</p>
            <SelectField
              value={this.props.departureDate}
              results={this.dateOfTravelOptions}
              handleMenuSelection={this.changeDepartureDate}
              iconColor='white'
              textColor='white'
              placeholderColor='white'
              bgColor='rgba(191, 191, 191, 0.66)'
              selectWrapperPosition='relative'
              inputFieldBg={false}
              secondaryAction={
                this.props.secondaryAdvancedSearchActionDepDate ?
                  this.secondaryAction : identity
              }
            />
          </div>
          <div className='advanced-search-bar advanced-search-bar-right half-search-bar'>
            <p>Time</p>
            <SelectField
              value={this.props.departureTime}
              results={this.timeOfTravelOptions}
              handleMenuSelection={this.changeDepartureTime}
              iconColor='white'
              textColor='white'
              placeholderColor='white'
              bgColor='rgba(191, 191, 191, 0.66)'
              selectWrapperPosition='relative'
              inputFieldBg={false}
              secondaryAction={
                this.props.secondaryAdvancedSearchActionTime ?
                  this.secondaryAction : identity
              }
            />
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/FlightTracker/components/Search/children/AdvancedSearch/AdvancedSearch.js